/**
 * Created by Ning Jiang on 11/23/2016.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {SpinMode} from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import {LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig, UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IWinRatios, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Back, Ease} from "gsap";
import {ITextStyles} from "../config/ITextStyles";
import {ThorDesktopTextStyles} from "../config/ThorDesktopTextStyles";
import {ThorMobileTextStyles} from "../config/ThorMobileTextStyles";
import {IThorLayerConfig} from "./stage/IThorLayerConfig";
import {IThorSymbolStates} from "./symbols/ThorReelSymbol";
import {ThorGameAssets} from "./ThorGameAssets";

export class ThorGameConfig implements IGameConfig {

    public static instance:ThorGameConfig = new ThorGameConfig();

    BROWSER_FPS:number = 30;

    GAME_WIDTH:number = 1280;
    GAME_HEIGHT:number = 720;

    static get TEXT_STYLES():ITextStyles {
        if(UserAgent.isMobile) {
            return ThorMobileTextStyles.instance;
        } else {
            return ThorDesktopTextStyles.instance;
        }
    }

    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };



    LAYERS:IThorLayerConfig = {
        HIDDEN : {name : "hidden"},
        BACKGROUND : {
            name : "background",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.5}
                    }
                }
            }
        },
        REEL_BACKGROUND : {
            name : "reelBackground",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        SYMBOLS : {
            name : "symbols",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        REEL_ATTENTION : {
            name : "reelAttention",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        WILD_OVERLAY : {
            name : "wildOverlay",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        MULTIPLIER : {
            name : "multiplier",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        BET_LINES : {
            name : "betLines",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        WIN_PRESENTATIONS : {
            name : "winPresentations",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        // FOREGROUND : {name: "foreground"},
        REELS_FRAME : {
            name : "reelsFrame",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        SCATTER_ANIMATION : {
            name : "scatterCounter",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        MJOLNIRTIME : {
            name : "mjolnirtime",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        RUNE_RAZE : {
            name : "runeRaze",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        BIG_WIN : {
            name : "bigWin",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        INITIAL_WIN_AMOUNT_BET_LINES : {
            name : "initialWInAmountBetLines",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        WIN_COUNT_UP : {
            name : "winCountUp",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        LOGO : {
            name : "winCountUp",
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        FREESPIN_INTRO : {
            name : "freespinIntro",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.55}
                    }
                }
            }
        },
        INTRO : {
            name : "introScreen",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                placement : {
                    desktop : {landscape : {x : 0.5, y : 0.5}},
                    mobile : {
                        landscape : {x : 0.5, y : 0.5},
                        portrait : {x : 0.5, y : 0.5}
                    }
                }
            }
        },
        TWEAK_MODULE: {name: "tweakModule", scaleOption: LayerScaleOption.FIT_WINDOW}
    };

    BET_WIN_MODE:BetWinMode = BetWinMode.BET_LINE;
    SPIN_MODE:SpinMode = SpinMode.SPIN;

    REEL_AREA_POS_X:number = 166;
    REEL_AREA_POS_Y:number = 70;
    REEL_AREA_WIDTH:number = 940;
    REEL_AREA_HEIGHT:number = 520;
    REEL_AREA_MASK_RECT:PIXI.Rectangle = new PIXI.Rectangle(203, 66, 870, 520);

    // GAME_TWEAKER_CONFIG: IGameTweakerConfig = {
    //     layer: this.LAYERS.TWEAK_MODULE.name,
    //     baseWindowWidth: 400,
    //     moduleHeight: 32,
    //     copyAllButtonText: "Copy All",
    //     buttonSkinIdle: "button",
    //     buttonSkinOver: "button",
    //     buttonSkinDown: "button",
    //     buttonSkinDisabled: "button-disabled"
    // };

    SYMBOL_STATES:IThorSymbolStates = {
        normal : {
            prio : 0,
            keyword : "normal",
            texturesCreator : (symName:string, stateKey:string) => {
                return ThorGameAssets.getSymbolStateTextures(symName);
            }
        },
        spin : {
            prio : 1,
            keyword : "spin",
            texturesCreator : (symName:string, stateKey:string) => {
                return ThorGameAssets.getSymbolStateTextures(symName, stateKey);
            }
        },
        noWin : {
            prio : 2,
            keyword : "noWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return ThorGameAssets.getSymbolStateTextures(symName);
            }
        },
        initialWin : {
            prio : 3,
            keyword : "initialWin"
        },
        win : {
            prio : 4,
            keyword : "win"
        },
        hidden : {
            prio : 5,
            keyword : "hidden"
        },
        sticky : {
            prio : 6,
            keyword : "sticky",
            symbols : ["W"]
        },
        land_1 : {
            prio : 7,
            keyword : "land_1",
            symbols : ["S"]
        },
        idleScatter_1 : {
            prio : 8,
            keyword : "idleScatter_1",
            symbols : ["S"]
        },
        attention : {
            prio : 9,
            keyword : "attention",
            symbols : ["S"]
        },
        idleScatter_2 : {
            prio : 10,
            keyword : "idleScatter_2",
            symbols : ["S"]
        },
        nudgeOut : {
            prio : 11,
            keyword : "nudgeOut",
            symbols : ["S"]
        },
        nudgeOutReversed : {
            prio : 12,
            keyword : "nudgeOutReversed",
            symbols : ["S"]
        },
        spinGlow : {
            prio : 13,
            keyword : "spinGlow",
            symbols : ["M1", "L1", "L2", "L3", "L4", "L5"]
        },
        lit : {
            prio : 14,
            keyword : "lit",
            symbols : ["M1", "L1", "L2", "L3", "L4", "L5"]
        }
    };
    SYMBOL_WIDTH:number = 170;
    SYMBOL_HEIGHT:number = 170;
    SYMBOL_BOTTOM_PADDING:number = 0;

    REELS_NUM:number = 5;
    SPACE_BETWEEN_REELS:number = 2;
    REEL_XPOS_OFFSET:number = 48;
    REEL_DISPLAY_POSITIONS:[number, number][] = [
        [this.REEL_XPOS_OFFSET + (this.SYMBOL_WIDTH * 0.5), 0],
        [this.REEL_XPOS_OFFSET + (this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS), 0],
        [this.REEL_XPOS_OFFSET + (this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS), 0],
        [this.REEL_XPOS_OFFSET + (this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS), 0],
        [this.REEL_XPOS_OFFSET + (this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS), 0]];
    SYMBOLS_NUM_IN_REEL:[number, number, number, number, number] = [0, 3, 3, 3, 0];


    REEL_SPIN_TIME:number = 0.9;
    REEL_FAST_SPIN_SPIN_TIME:number = 0.2;
    MIN_STOPPING_TIME:number = 2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY:number = 0.3;
    REEL_SPIN_START_EASE:Ease = Back.easeIn.config(4);
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY:number = 0;
    REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [1.5, 0.95];
    //REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [1, 1];
    //REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [1.2, 0.75];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [0.1, 0.1];

    REEL_SPIN_START_SPEED:number = 0.3;
    REEL_SPIN_SPIN_SPEED:number = 0.04;
    REEL_NEAR_WIN_SPIN_SPEED:number = 0.03;
    REEL_SPIN_STOP_SPEED:number = 0.3;
    REEL_SPIN_QUICK_STOP_SPEED:number = 0.3;

    REEL_STOP_DELAY:number = 0.4;
    REEL_QUICK_STOP_DELAY:number = 0.15;
    REEL_NEAR_WIN_STOP_DELAY:number = 3.0;

    REEL_SETS:any = {
        "RUNE_RAZE_L1" : [
            [
                "M4", "L1", "L1", "L1", "L1", "M4", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "M2",
                "L1", "L1", "L1", "M2", "L1", "L1", "M1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "L1",
                "M4", "L1", "L1", "L1", "L1", "M5", "L1", "L1", "L1", "M2", "L1", "L1", "M1", "M4", "L1",
                "L1", "L1", "M4", "L1", "M2", "L1", "M4", "L1", "L1", "L1", "L1", "L1", "M2", "L1", "M1",
                "L1", "L1", "L1", "L1", "M5", "M4", "L1", "L1", "M2", "L1", "L1", "L1", "M4", "L1", "L1",
                "L1", "M4", "L1", "M3", "L1", "M1", "L1", "L1", "L1", "L1", "M5", "M2", "L1", "L1", "M2",
                "L1", "M5", "L1", "M4", "M5", "L1", "L1", "L1", "L1", "L1", "M3", "L1", "M2", "L1", "L1",
                "M1", "L1", "L1", "L1", "L1", "M4", "M3", "L1", "M1", "L1", "M4", "L1", "M1", "L1", "M5",
                "M4", "L1", "L1", "M2", "L1", "L1", "L1", "L1", "L1", "L1", "M2", "M1", "L1", "M4", "L1",
                "M3", "L1", "L1", "M4", "L1", "L1", "M2", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1",
                "M2", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "L1", "L1"
            ],
            [
                "L1", "L1", "M2", "L1", "M3", "L1", "L1", "M2", "L1", "M5", "M4", "L1", "L1", "L1", "L1",
                "M4", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2", "L1",
                "L1", "M1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "L1", "M4", "L1", "L1", "L1", "L1",
                "M5", "L1", "L1", "L1", "M2", "L1", "L1", "M1", "M4", "L1", "L1", "L1", "M4", "L1", "M2",
                "L1", "M4", "L1", "L1", "L1", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "L1", "M5",
                "M4", "L1", "L1", "M2", "L1", "L1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "M3", "L1",
                "M1", "L1", "L1", "L1", "L1", "M5", "M2", "L1", "L1", "M2", "L1", "M5", "L1", "M4", "M5",
                "L1", "L1", "L1", "L1", "L1", "M3", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "L1",
                "M4", "M3", "L1", "M1", "L1", "M4", "L1", "M1", "L1", "M5", "M4", "L1", "L1", "M2", "L1",
                "L1", "L1", "L1", "L1", "L1", "M2", "M1", "L1", "M4", "L1", "M3", "L1", "L1", "M4", "L1",
                "L1", "M2", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2",
                "L1", "L1", "L1", "L1", "L1"
            ],
            [
                "L1", "L1", "M3", "M5", "L1", "L1", "M4", "L1", "L1", "M3", "M4", "L1", "L1", "L1", "L1",
                "M4", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2", "L1",
                "L1", "M1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "L1", "M4", "L1", "L1", "L1", "L1",
                "M5", "L1", "L1", "L1", "M2", "L1", "L1", "M1", "M4", "L1", "L1", "L1", "M4", "L1", "M2",
                "L1", "M4", "L1", "L1", "L1", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "L1", "M5",
                "M4", "L1", "L1", "M2", "L1", "L1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "M3", "L1",
                "M1", "L1", "L1", "L1", "L1", "M5", "M2", "L1", "L1", "M2", "L1", "M5", "L1", "M4", "M5",
                "L1", "L1", "L1", "L1", "L1", "M3", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "L1",
                "M4", "M3", "L1", "M1", "L1", "M4", "L1", "M1", "L1", "M5", "M4", "L1", "L1", "M2", "L1",
                "L1", "L1", "L1", "L1", "L1", "M2", "M1", "L1", "M4", "L1", "M3", "L1", "L1", "M4", "L1",
                "L1", "M2", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2",
                "L1", "L1", "L1", "L1", "L1"
            ],
            [
                "L1", "L1", "L1", "M4", "M3", "L1", "M2", "L1", "L1", "M3", "M4", "L1", "L1", "L1", "L1",
                "M4", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2", "L1",
                "L1", "M1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "L1", "M4", "L1", "L1", "L1", "L1",
                "M5", "L1", "L1", "L1", "M2", "L1", "L1", "M1", "M4", "L1", "L1", "L1", "M4", "L1", "M2",
                "L1", "M4", "L1", "L1", "L1", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "L1", "M5",
                "M4", "L1", "L1", "M2", "L1", "L1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "M3", "L1",
                "M1", "L1", "L1", "L1", "L1", "M5", "M2", "L1", "L1", "M2", "L1", "M5", "L1", "M4", "M5",
                "L1", "L1", "L1", "L1", "L1", "M3", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "L1",
                "M4", "M3", "L1", "M1", "L1", "M4", "L1", "M1", "L1", "M5", "M4", "L1", "L1", "M2", "L1",
                "L1", "L1", "L1", "L1", "L1", "M2", "M1", "L1", "M4", "L1", "M3", "L1", "L1", "M4", "L1",
                "L1", "M2", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2",
                "L1", "L1", "L1", "L1", "L1"
            ],
            [
                "L1", "L1", "M5", "M1", "M3", "L1", "M4", "L1", "L1", "M5", "M3", "M4", "L1", "L1", "L1",
                "L1", "M4", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1", "M2",
                "L1", "L1", "M1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "L1", "M4", "L1", "L1", "L1",
                "L1", "M5", "L1", "L1", "L1", "M2", "L1", "L1", "M1", "M4", "L1", "L1", "L1", "M4", "L1",
                "M2", "L1", "M4", "L1", "L1", "L1", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "L1",
                "M5", "M4", "L1", "L1", "M2", "L1", "L1", "L1", "M4", "L1", "L1", "L1", "M4", "L1", "M3",
                "L1", "M1", "L1", "L1", "L1", "L1", "M5", "M2", "L1", "L1", "M2", "L1", "M5", "L1", "M4",
                "M5", "L1", "L1", "L1", "L1", "L1", "M3", "L1", "M2", "L1", "L1", "M1", "L1", "L1", "L1",
                "L1", "M4", "M3", "L1", "M1", "L1", "M4", "L1", "M1", "L1", "M5", "M4", "L1", "L1", "M2",
                "L1", "L1", "L1", "L1", "L1", "L1", "M2", "M1", "L1", "M4", "L1", "M3", "L1", "L1", "M4",
                "L1", "L1", "M2", "L1", "L1", "M2", "L1", "M1", "L1", "L1", "L1", "M2", "L1", "L1", "L1",
                "M2", "L1", "L1", "L1", "L1", "L1"
            ]
        ],
        "RUNE_RAZE_L2" : [
            [
                "M4", "L2", "L2", "L2", "L2", "M4", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "M2",
                "L2", "L2", "L2", "M2", "L2", "L2", "M1", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "L2",
                "M4", "L2", "L2", "L2", "L2", "M5", "L2", "L2", "L2", "M2", "L2", "L2", "M1", "M4", "L2",
                "L2", "L2", "M4", "L2", "M2", "L2", "M4", "L2", "L2", "L2", "L2", "L2", "M2", "L2", "M1",
                "L2", "L2", "L2", "L2", "M5", "M4", "L2", "L2", "M2", "L2", "L2", "L2", "M4", "L2", "L2",
                "L2", "M4", "L2", "M3", "L2", "M1", "L2", "L2", "L2", "L2", "M5", "M2", "L2", "L2", "M2",
                "L2", "M5", "L2", "M4", "M5", "L2", "L2", "L2", "L2", "L2", "M3", "L2", "M2", "L2", "L2",
                "M1", "L2", "L2", "L2", "L2", "M4", "M3", "L2", "M1", "L2", "M4", "L2", "M1", "L2", "M5",
                "M4", "L2", "L2", "M2", "L2", "L2", "L2", "L2", "L2", "L2", "M2", "M1", "L2", "M4", "L2",
                "M3", "L2", "L2", "M4", "L2", "L2", "M2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2",
                "M2", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "L2", "L2"
            ],
            [
                "L2", "L2", "M2", "L2", "M3", "L2", "L2", "M2", "L2", "M5", "M4", "L2", "L2", "L2", "L2",
                "M4", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2", "L2",
                "L2", "M1", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "L2", "M4", "L2", "L2", "L2", "L2",
                "M5", "L2", "L2", "L2", "M2", "L2", "L2", "M1", "M4", "L2", "L2", "L2", "M4", "L2", "M2",
                "L2", "M4", "L2", "L2", "L2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "L2", "M5",
                "M4", "L2", "L2", "M2", "L2", "L2", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "M3", "L2",
                "M1", "L2", "L2", "L2", "L2", "M5", "M2", "L2", "L2", "M2", "L2", "M5", "L2", "M4", "M5",
                "L2", "L2", "L2", "L2", "L2", "M3", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "L2",
                "M4", "M3", "L2", "M1", "L2", "M4", "L2", "M1", "L2", "M5", "M4", "L2", "L2", "M2", "L2",
                "L2", "L2", "L2", "L2", "L2", "M2", "M1", "L2", "M4", "L2", "M3", "L2", "L2", "M4", "L2",
                "L2", "M2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2",
                "L2", "L2", "L2", "L2", "L2"
            ],
            [
                "L2", "L2", "M3", "M5", "L2", "L2", "M4", "L2", "L2", "M3", "M4", "L2", "L2", "L2", "L2",
                "M4", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2", "L2",
                "L2", "M1", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "L2", "M4", "L2", "L2", "L2", "L2",
                "M5", "L2", "L2", "L2", "M2", "L2", "L2", "M1", "M4", "L2", "L2", "L2", "M4", "L2", "M2",
                "L2", "M4", "L2", "L2", "L2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "L2", "M5",
                "M4", "L2", "L2", "M2", "L2", "L2", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "M3", "L2",
                "M1", "L2", "L2", "L2", "L2", "M5", "M2", "L2", "L2", "M2", "L2", "M5", "L2", "M4", "M5",
                "L2", "L2", "L2", "L2", "L2", "M3", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "L2",
                "M4", "M3", "L2", "M1", "L2", "M4", "L2", "M1", "L2", "M5", "M4", "L2", "L2", "M2", "L2",
                "L2", "L2", "L2", "L2", "L2", "M2", "M1", "L2", "M4", "L2", "M3", "L2", "L2", "M4", "L2",
                "L2", "M2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2",
                "L2", "L2", "L2", "L2", "L2"
            ],
            [
                "L2", "L2", "L2", "M4", "M3", "L2", "M2", "L2", "L2", "M3", "M4", "L2", "L2", "L2", "L2",
                "M4", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2", "L2",
                "L2", "M1", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "L2", "M4", "L2", "L2", "L2", "L2",
                "M5", "L2", "L2", "L2", "M2", "L2", "L2", "M1", "M4", "L2", "L2", "L2", "M4", "L2", "M2",
                "L2", "M4", "L2", "L2", "L2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "L2", "M5",
                "M4", "L2", "L2", "M2", "L2", "L2", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "M3", "L2",
                "M1", "L2", "L2", "L2", "L2", "M5", "M2", "L2", "L2", "M2", "L2", "M5", "L2", "M4", "M5",
                "L2", "L2", "L2", "L2", "L2", "M3", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "L2",
                "M4", "M3", "L2", "M1", "L2", "M4", "L2", "M1", "L2", "M5", "M4", "L2", "L2", "M2", "L2",
                "L2", "L2", "L2", "L2", "L2", "M2", "M1", "L2", "M4", "L2", "M3", "L2", "L2", "M4", "L2",
                "L2", "M2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2",
                "L2", "L2", "L2", "L2", "L2"
            ],
            [
                "L2", "L2", "M5", "M1", "M3", "L2", "M4", "L2", "L2", "M5", "M3", "M4", "L2", "L2", "L2",
                "L2", "M4", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2", "M2",
                "L2", "L2", "M1", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "L2", "M4", "L2", "L2", "L2",
                "L2", "M5", "L2", "L2", "L2", "M2", "L2", "L2", "M1", "M4", "L2", "L2", "L2", "M4", "L2",
                "M2", "L2", "M4", "L2", "L2", "L2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "L2",
                "M5", "M4", "L2", "L2", "M2", "L2", "L2", "L2", "M4", "L2", "L2", "L2", "M4", "L2", "M3",
                "L2", "M1", "L2", "L2", "L2", "L2", "M5", "M2", "L2", "L2", "M2", "L2", "M5", "L2", "M4",
                "M5", "L2", "L2", "L2", "L2", "L2", "M3", "L2", "M2", "L2", "L2", "M1", "L2", "L2", "L2",
                "L2", "M4", "M3", "L2", "M1", "L2", "M4", "L2", "M1", "L2", "M5", "M4", "L2", "L2", "M2",
                "L2", "L2", "L2", "L2", "L2", "L2", "M2", "M1", "L2", "M4", "L2", "M3", "L2", "L2", "M4",
                "L2", "L2", "M2", "L2", "L2", "M2", "L2", "M1", "L2", "L2", "L2", "M2", "L2", "L2", "L2",
                "M2", "L2", "L2", "L2", "L2", "L2"
            ]
        ],
        "RUNE_RAZE_L3" : [
            [
                "M4", "L3", "L3", "L3", "L3", "M4", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "M2",
                "L3", "L3", "L3", "M2", "L3", "L3", "M1", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "L3",
                "M4", "L3", "L3", "L3", "L3", "M5", "L3", "L3", "L3", "M2", "L3", "L3", "M1", "M4", "L3",
                "L3", "L3", "M4", "L3", "M2", "L3", "M4", "L3", "L3", "L3", "L3", "L3", "M2", "L3", "M1",
                "L3", "L3", "L3", "L3", "M5", "M4", "L3", "L3", "M2", "L3", "L3", "L3", "M4", "L3", "L3",
                "L3", "M4", "L3", "M3", "L3", "M1", "L3", "L3", "L3", "L3", "M5", "M2", "L3", "L3", "M2",
                "L3", "M5", "L3", "M4", "M5", "L3", "L3", "L3", "L3", "L3", "M3", "L3", "M2", "L3", "L3",
                "M1", "L3", "L3", "L3", "L3", "M4", "M3", "L3", "M1", "L3", "M4", "L3", "M1", "L3", "M5",
                "M4", "L3", "L3", "M2", "L3", "L3", "L3", "L3", "L3", "L3", "M2", "M1", "L3", "M4", "L3",
                "M3", "L3", "L3", "M4", "L3", "L3", "M2", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3",
                "M2", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "L3", "L3"
            ],
            [
                "L3", "L3", "M2", "L3", "M3", "L3", "L3", "M2", "L3", "M5", "M4", "L3", "L3", "L3", "L3",
                "M4", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2", "L3",
                "L3", "M1", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "L3", "M4", "L3", "L3", "L3", "L3",
                "M5", "L3", "L3", "L3", "M2", "L3", "L3", "M1", "M4", "L3", "L3", "L3", "M4", "L3", "M2",
                "L3", "M4", "L3", "L3", "L3", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "L3", "M5",
                "M4", "L3", "L3", "M2", "L3", "L3", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "M3", "L3",
                "M1", "L3", "L3", "L3", "L3", "M5", "M2", "L3", "L3", "M2", "L3", "M5", "L3", "M4", "M5",
                "L3", "L3", "L3", "L3", "L3", "M3", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "L3",
                "M4", "M3", "L3", "M1", "L3", "M4", "L3", "M1", "L3", "M5", "M4", "L3", "L3", "M2", "L3",
                "L3", "L3", "L3", "L3", "L3", "M2", "M1", "L3", "M4", "L3", "M3", "L3", "L3", "M4", "L3",
                "L3", "M2", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2",
                "L3", "L3", "L3", "L3", "L3"
            ],
            [
                "L3", "L3", "M3", "M5", "L3", "L3", "M4", "L3", "L3", "M3", "M4", "L3", "L3", "L3", "L3",
                "M4", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2", "L3",
                "L3", "M1", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "L3", "M4", "L3", "L3", "L3", "L3",
                "M5", "L3", "L3", "L3", "M2", "L3", "L3", "M1", "M4", "L3", "L3", "L3", "M4", "L3", "M2",
                "L3", "M4", "L3", "L3", "L3", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "L3", "M5",
                "M4", "L3", "L3", "M2", "L3", "L3", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "M3", "L3",
                "M1", "L3", "L3", "L3", "L3", "M5", "M2", "L3", "L3", "M2", "L3", "M5", "L3", "M4", "M5",
                "L3", "L3", "L3", "L3", "L3", "M3", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "L3",
                "M4", "M3", "L3", "M1", "L3", "M4", "L3", "M1", "L3", "M5", "M4", "L3", "L3", "M2", "L3",
                "L3", "L3", "L3", "L3", "L3", "M2", "M1", "L3", "M4", "L3", "M3", "L3", "L3", "M4", "L3",
                "L3", "M2", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2",
                "L3", "L3", "L3", "L3", "L3"
            ],
            [
                "L3", "L3", "L3", "M4", "M3", "L3", "M2", "L3", "L3", "M3", "M4", "L3", "L3", "L3", "L3",
                "M4", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2", "L3",
                "L3", "M1", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "L3", "M4", "L3", "L3", "L3", "L3",
                "M5", "L3", "L3", "L3", "M2", "L3", "L3", "M1", "M4", "L3", "L3", "L3", "M4", "L3", "M2",
                "L3", "M4", "L3", "L3", "L3", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "L3", "M5",
                "M4", "L3", "L3", "M2", "L3", "L3", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "M3", "L3",
                "M1", "L3", "L3", "L3", "L3", "M5", "M2", "L3", "L3", "M2", "L3", "M5", "L3", "M4", "M5",
                "L3", "L3", "L3", "L3", "L3", "M3", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "L3",
                "M4", "M3", "L3", "M1", "L3", "M4", "L3", "M1", "L3", "M5", "M4", "L3", "L3", "M2", "L3",
                "L3", "L3", "L3", "L3", "L3", "M2", "M1", "L3", "M4", "L3", "M3", "L3", "L3", "M4", "L3",
                "L3", "M2", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2",
                "L3", "L3", "L3", "L3", "L3"
            ],
            [
                "L3", "L3", "M5", "M1", "M3", "L3", "M4", "L3", "L3", "M5", "M3", "M4", "L3", "L3", "L3",
                "L3", "M4", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3", "M2",
                "L3", "L3", "M1", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "L3", "M4", "L3", "L3", "L3",
                "L3", "M5", "L3", "L3", "L3", "M2", "L3", "L3", "M1", "M4", "L3", "L3", "L3", "M4", "L3",
                "M2", "L3", "M4", "L3", "L3", "L3", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "L3",
                "M5", "M4", "L3", "L3", "M2", "L3", "L3", "L3", "M4", "L3", "L3", "L3", "M4", "L3", "M3",
                "L3", "M1", "L3", "L3", "L3", "L3", "M5", "M2", "L3", "L3", "M2", "L3", "M5", "L3", "M4",
                "M5", "L3", "L3", "L3", "L3", "L3", "M3", "L3", "M2", "L3", "L3", "M1", "L3", "L3", "L3",
                "L3", "M4", "M3", "L3", "M1", "L3", "M4", "L3", "M1", "L3", "M5", "M4", "L3", "L3", "M2",
                "L3", "L3", "L3", "L3", "L3", "L3", "M2", "M1", "L3", "M4", "L3", "M3", "L3", "L3", "M4",
                "L3", "L3", "M2", "L3", "L3", "M2", "L3", "M1", "L3", "L3", "L3", "M2", "L3", "L3", "L3",
                "M2", "L3", "L3", "L3", "L3", "L3"
            ]
        ],
        "RUNE_RAZE_L4" : [
            [
                "M4", "L4", "L4", "L4", "L4", "M4", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "M2",
                "L4", "L4", "L4", "M2", "L4", "L4", "M1", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "L4",
                "M4", "L4", "L4", "L4", "L4", "M5", "L4", "L4", "L4", "M2", "L4", "L4", "M1", "M4", "L4",
                "L4", "L4", "M4", "L4", "M2", "L4", "M4", "L4", "L4", "L4", "L4", "L4", "M2", "L4", "M1",
                "L4", "L4", "L4", "L4", "M5", "M4", "L4", "L4", "M2", "L4", "L4", "L4", "M4", "L4", "L4",
                "L4", "M4", "L4", "M3", "L4", "M1", "L4", "L4", "L4", "L4", "M5", "M2", "L4", "L4", "M2",
                "L4", "M5", "L4", "M4", "M5", "L4", "L4", "L4", "L4", "L4", "M3", "L4", "M2", "L4", "L4",
                "M1", "L4", "L4", "L4", "L4", "M4", "M3", "L4", "M1", "L4", "M4", "L4", "M1", "L4", "M5",
                "M4", "L4", "L4", "M2", "L4", "L4", "L4", "L4", "L4", "L4", "M2", "M1", "L4", "M4", "L4",
                "M3", "L4", "L4", "M4", "L4", "L4", "M2", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4",
                "M2", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "L4", "L4"
            ],
            [
                "L4", "L4", "M2", "L4", "M3", "L4", "L4", "M2", "L4", "M5", "M4", "L4", "L4", "L4", "L4",
                "M4", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2", "L4",
                "L4", "M1", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "L4", "M4", "L4", "L4", "L4", "L4",
                "M5", "L4", "L4", "L4", "M2", "L4", "L4", "M1", "M4", "L4", "L4", "L4", "M4", "L4", "M2",
                "L4", "M4", "L4", "L4", "L4", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "L4", "M5",
                "M4", "L4", "L4", "M2", "L4", "L4", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "M3", "L4",
                "M1", "L4", "L4", "L4", "L4", "M5", "M2", "L4", "L4", "M2", "L4", "M5", "L4", "M4", "M5",
                "L4", "L4", "L4", "L4", "L4", "M3", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "L4",
                "M4", "M3", "L4", "M1", "L4", "M4", "L4", "M1", "L4", "M5", "M4", "L4", "L4", "M2", "L4",
                "L4", "L4", "L4", "L4", "L4", "M2", "M1", "L4", "M4", "L4", "M3", "L4", "L4", "M4", "L4",
                "L4", "M2", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2",
                "L4", "L4", "L4", "L4", "L4"
            ],
            [
                "L4", "L4", "M3", "M5", "L4", "L4", "M4", "L4", "L4", "M3", "M4", "L4", "L4", "L4", "L4",
                "M4", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2", "L4",
                "L4", "M1", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "L4", "M4", "L4", "L4", "L4", "L4",
                "M5", "L4", "L4", "L4", "M2", "L4", "L4", "M1", "M4", "L4", "L4", "L4", "M4", "L4", "M2",
                "L4", "M4", "L4", "L4", "L4", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "L4", "M5",
                "M4", "L4", "L4", "M2", "L4", "L4", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "M3", "L4",
                "M1", "L4", "L4", "L4", "L4", "M5", "M2", "L4", "L4", "M2", "L4", "M5", "L4", "M4", "M5",
                "L4", "L4", "L4", "L4", "L4", "M3", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "L4",
                "M4", "M3", "L4", "M1", "L4", "M4", "L4", "M1", "L4", "M5", "M4", "L4", "L4", "M2", "L4",
                "L4", "L4", "L4", "L4", "L4", "M2", "M1", "L4", "M4", "L4", "M3", "L4", "L4", "M4", "L4",
                "L4", "M2", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2",
                "L4", "L4", "L4", "L4", "L4"
            ],
            [
                "L4", "L4", "L4", "M4", "M3", "L4", "M2", "L4", "L4", "M3", "M4", "L4", "L4", "L4", "L4",
                "M4", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2", "L4",
                "L4", "M1", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "L4", "M4", "L4", "L4", "L4", "L4",
                "M5", "L4", "L4", "L4", "M2", "L4", "L4", "M1", "M4", "L4", "L4", "L4", "M4", "L4", "M2",
                "L4", "M4", "L4", "L4", "L4", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "L4", "M5",
                "M4", "L4", "L4", "M2", "L4", "L4", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "M3", "L4",
                "M1", "L4", "L4", "L4", "L4", "M5", "M2", "L4", "L4", "M2", "L4", "M5", "L4", "M4", "M5",
                "L4", "L4", "L4", "L4", "L4", "M3", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "L4",
                "M4", "M3", "L4", "M1", "L4", "M4", "L4", "M1", "L4", "M5", "M4", "L4", "L4", "M2", "L4",
                "L4", "L4", "L4", "L4", "L4", "M2", "M1", "L4", "M4", "L4", "M3", "L4", "L4", "M4", "L4",
                "L4", "M2", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2",
                "L4", "L4", "L4", "L4", "L4"
            ],
            [
                "L4", "L4", "M5", "M1", "M3", "L4", "M4", "L4", "L4", "M5", "M3", "M4", "L4", "L4", "L4",
                "L4", "M4", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4", "M2",
                "L4", "L4", "M1", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "L4", "M4", "L4", "L4", "L4",
                "L4", "M5", "L4", "L4", "L4", "M2", "L4", "L4", "M1", "M4", "L4", "L4", "L4", "M4", "L4",
                "M2", "L4", "M4", "L4", "L4", "L4", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "L4",
                "M5", "M4", "L4", "L4", "M2", "L4", "L4", "L4", "M4", "L4", "L4", "L4", "M4", "L4", "M3",
                "L4", "M1", "L4", "L4", "L4", "L4", "M5", "M2", "L4", "L4", "M2", "L4", "M5", "L4", "M4",
                "M5", "L4", "L4", "L4", "L4", "L4", "M3", "L4", "M2", "L4", "L4", "M1", "L4", "L4", "L4",
                "L4", "M4", "M3", "L4", "M1", "L4", "M4", "L4", "M1", "L4", "M5", "M4", "L4", "L4", "M2",
                "L4", "L4", "L4", "L4", "L4", "L4", "M2", "M1", "L4", "M4", "L4", "M3", "L4", "L4", "M4",
                "L4", "L4", "M2", "L4", "L4", "M2", "L4", "M1", "L4", "L4", "L4", "M2", "L4", "L4", "L4",
                "M2", "L4", "L4", "L4", "L4", "L4"
            ]
        ],
        "RUNE_RAZE_L5" : [
            [
                "M4", "L5", "L5", "L5", "L5", "M4", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "M2",
                "L5", "L5", "L5", "M2", "L5", "L5", "M1", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "L5",
                "M4", "L5", "L5", "L5", "L5", "M5", "L5", "L5", "L5", "M2", "L5", "L5", "M1", "M4", "L5",
                "L5", "L5", "M4", "L5", "M2", "L5", "M4", "L5", "L5", "L5", "L5", "L5", "M2", "L5", "M1",
                "L5", "L5", "L5", "L5", "M5", "M4", "L5", "L5", "M2", "L5", "L5", "L5", "M4", "L5", "L5",
                "L5", "M4", "L5", "M3", "L5", "M1", "L5", "L5", "L5", "L5", "M5", "M2", "L5", "L5", "M2",
                "L5", "M5", "L5", "M4", "M5", "L5", "L5", "L5", "L5", "L5", "M3", "L5", "M2", "L5", "L5",
                "M1", "L5", "L5", "L5", "L5", "M4", "M3", "L5", "M1", "L5", "M4", "L5", "M1", "L5", "M5",
                "M4", "L5", "L5", "M2", "L5", "L5", "L5", "L5", "L5", "L5", "M2", "M1", "L5", "M4", "L5",
                "M3", "L5", "L5", "M4", "L5", "L5", "M2", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5",
                "M2", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "L5", "L5"
            ],
            [
                "L5", "L5", "M2", "L5", "M3", "L5", "L5", "M2", "L5", "M5", "M4", "L5", "L5", "L5", "L5",
                "M4", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2", "L5",
                "L5", "M1", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "L5", "M4", "L5", "L5", "L5", "L5",
                "M5", "L5", "L5", "L5", "M2", "L5", "L5", "M1", "M4", "L5", "L5", "L5", "M4", "L5", "M2",
                "L5", "M4", "L5", "L5", "L5", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "L5", "M5",
                "M4", "L5", "L5", "M2", "L5", "L5", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "M3", "L5",
                "M1", "L5", "L5", "L5", "L5", "M5", "M2", "L5", "L5", "M2", "L5", "M5", "L5", "M4", "M5",
                "L5", "L5", "L5", "L5", "L5", "M3", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "L5",
                "M4", "M3", "L5", "M1", "L5", "M4", "L5", "M1", "L5", "M5", "M4", "L5", "L5", "M2", "L5",
                "L5", "L5", "L5", "L5", "L5", "M2", "M1", "L5", "M4", "L5", "M3", "L5", "L5", "M4", "L5",
                "L5", "M2", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2",
                "L5", "L5", "L5", "L5", "L5"
            ],
            [
                "L5", "L5", "M3", "M5", "L5", "L5", "M4", "L5", "L5", "M3", "M4", "L5", "L5", "L5", "L5",
                "M4", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2", "L5",
                "L5", "M1", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "L5", "M4", "L5", "L5", "L5", "L5",
                "M5", "L5", "L5", "L5", "M2", "L5", "L5", "M1", "M4", "L5", "L5", "L5", "M4", "L5", "M2",
                "L5", "M4", "L5", "L5", "L5", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "L5", "M5",
                "M4", "L5", "L5", "M2", "L5", "L5", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "M3", "L5",
                "M1", "L5", "L5", "L5", "L5", "M5", "M2", "L5", "L5", "M2", "L5", "M5", "L5", "M4", "M5",
                "L5", "L5", "L5", "L5", "L5", "M3", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "L5",
                "M4", "M3", "L5", "M1", "L5", "M4", "L5", "M1", "L5", "M5", "M4", "L5", "L5", "M2", "L5",
                "L5", "L5", "L5", "L5", "L5", "M2", "M1", "L5", "M4", "L5", "M3", "L5", "L5", "M4", "L5",
                "L5", "M2", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2",
                "L5", "L5", "L5", "L5", "L5"
            ],
            [
                "L5", "L5", "L5", "M4", "M3", "L5", "M2", "L5", "L5", "M3", "M4", "L5", "L5", "L5", "L5",
                "M4", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2", "L5",
                "L5", "M1", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "L5", "M4", "L5", "L5", "L5", "L5",
                "M5", "L5", "L5", "L5", "M2", "L5", "L5", "M1", "M4", "L5", "L5", "L5", "M4", "L5", "M2",
                "L5", "M4", "L5", "L5", "L5", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "L5", "M5",
                "M4", "L5", "L5", "M2", "L5", "L5", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "M3", "L5",
                "M1", "L5", "L5", "L5", "L5", "M5", "M2", "L5", "L5", "M2", "L5", "M5", "L5", "M4", "M5",
                "L5", "L5", "L5", "L5", "L5", "M3", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "L5",
                "M4", "M3", "L5", "M1", "L5", "M4", "L5", "M1", "L5", "M5", "M4", "L5", "L5", "M2", "L5",
                "L5", "L5", "L5", "L5", "L5", "M2", "M1", "L5", "M4", "L5", "M3", "L5", "L5", "M4", "L5",
                "L5", "M2", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2",
                "L5", "L5", "L5", "L5", "L5"
            ],
            [
                "L5", "L5", "M5", "M1", "M3", "L5", "M4", "L5", "L5", "M5", "M3", "M4", "L5", "L5", "L5",
                "L5", "M4", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5", "M2",
                "L5", "L5", "M1", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "L5", "M4", "L5", "L5", "L5",
                "L5", "M5", "L5", "L5", "L5", "M2", "L5", "L5", "M1", "M4", "L5", "L5", "L5", "M4", "L5",
                "M2", "L5", "M4", "L5", "L5", "L5", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "L5",
                "M5", "M4", "L5", "L5", "M2", "L5", "L5", "L5", "M4", "L5", "L5", "L5", "M4", "L5", "M3",
                "L5", "M1", "L5", "L5", "L5", "L5", "M5", "M2", "L5", "L5", "M2", "L5", "M5", "L5", "M4",
                "M5", "L5", "L5", "L5", "L5", "L5", "M3", "L5", "M2", "L5", "L5", "M1", "L5", "L5", "L5",
                "L5", "M4", "M3", "L5", "M1", "L5", "M4", "L5", "M1", "L5", "M5", "M4", "L5", "L5", "M2",
                "L5", "L5", "L5", "L5", "L5", "L5", "M2", "M1", "L5", "M4", "L5", "M3", "L5", "L5", "M4",
                "L5", "L5", "M2", "L5", "L5", "M2", "L5", "M1", "L5", "L5", "L5", "M2", "L5", "L5", "L5",
                "M2", "L5", "L5", "L5", "L5", "L5"
            ]
        ],
        "HAMMERTIME" : [
            [
                "M1", "L5", "L4", "L1", "L2", "M1", "L1", "M1", "L5", "L2", "M1", "L3", "L4", "M1", "L5",
                "M1", "L4", "L1", "M1", "L3", "M1", "M1", "L5", "L4", "L1", "L2", "M1", "L1", "M1", "L5",
                "L2", "M1", "L4", "L3", "M1", "M1", "L4", "L1", "M1", "L2", "L4", "M1", "M1", "L5", "L4",
                "L1", "L2", "M1", "L1", "M1", "L5", "L2", "M1", "L2", "L5", "L3", "M1", "M1", "L3", "M1",
                "L5", "L2", "M1", "L1", "L5", "M1", "L3", "M1", "L5", "M1", "L2", "L5", "M1", "M1"
            ],
            [
                "L3", "L4", "M1", "L5", "M1", "L4", "L1", "M1", "L3", "M1", "M1", "L5", "L4", "L1", "L2",
                "M1", "L1", "M1", "L5", "L2", "M1", "L3", "L4", "M1", "L5", "M1", "L4", "L1", "M1", "L3",
                "M1", "L4", "L3", "M1", "M1", "L4", "L1", "M1", "L2", "L4", "M1", "L3", "L4", "M1", "L5",
                "M1", "L4", "L1", "M1", "L3", "M1", "L2", "L5", "L3", "M1", "M1", "L3", "M1", "L5", "L2",
                "M1", "L1", "L5", "M1", "L3", "M1", "L5", "M1", "L2", "L5", "M1", "M1"
            ],
            [
                "L4", "L3", "M1", "M1", "L4", "L1", "M1", "L2", "L4", "M1", "M1", "L5", "L4", "L1", "L2",
                "M1", "L1", "M1", "L5", "L2", "M1", "L4", "L3", "M1", "M1", "L4", "L1", "M1", "L2", "L4",
                "M1", "L3", "L4", "M1", "L5", "M1", "L4", "L1", "M1", "L3", "M1", "L1", "L5", "M1", "L3",
                "M1", "L5", "M1", "L2", "L5", "M1", "M1", "L4", "L3", "M1", "M1", "L4", "L1", "M1", "L2",
                "L4", "M1", "L2", "L5", "L3", "M1", "M1", "L3", "M1", "L5", "L2", "M1"
            ],
            [
                "L2", "L5", "L3", "M1", "M1", "L3", "M1", "L5", "L2", "M1", "M1", "L5", "L4", "L1", "L2",
                "M1", "L1", "M1", "L5", "L2", "M1", "L2", "L5", "L3", "M1", "M1", "L3", "M1", "L5", "L2",
                "M1", "L3", "L4", "M1", "L5", "M1", "L4", "L1", "M1", "L3", "M1", "L1", "L5", "M1", "L3",
                "M1", "L5", "M1", "L2", "L5", "M1", "M1", "L2", "L5", "L3", "M1", "M1", "L3", "M1", "L5",
                "L2", "M1", "L4", "L3", "M1", "M1", "L4", "L1", "M1", "L2", "L4", "M1"
            ],
            [
                "L1", "L5", "M1", "L3", "M1", "L5", "M1", "L2", "L5", "M1", "M1", "M1", "L5", "L4", "L1",
                "L2", "M1", "L1", "M1", "L5", "L2", "M1", "L1", "L5", "M1", "L3", "M1", "L5", "M1", "L2",
                "L5", "M1", "M1", "L3", "L4", "M1", "L5", "M1", "L4", "L1", "M1", "L3", "M1", "L1", "L5",
                "M1", "L3", "M1", "L5", "M1", "L2", "L5", "M1", "M1", "L2", "L5", "L3", "M1", "M1", "L3",
                "M1", "L5", "L2", "M1"
            ]
        ],
        "BASE_REELSET" : [
            [
                "M4", "L5", "L4", "L1", "L2", "M4", "L1", "M2", "L5", "L2", "M1", "L3", "L5", "L4", "M2",
                "L5", "L1", "L2", "M2", "L5", "L3", "M1", "L2", "M4", "L5", "L1", "L4", "M4", "L5", "L1",
                "M4", "L2", "W", "L3", "L4", "L2", "M5", "L3", "L2", "L1", "M2", "L2", "L3", "M1", "M4",
                "L5", "L3", "L1", "M4", "L5", "M2", "L3", "M4", "L2", "M5", "M2", "L3", "L1", "M2", "L2",
                "M5", "L5", "M4", "M5", "S", "L3", "L2", "L4", "L1", "L3", "M3", "L1", "M2", "L2", "L3",
                "M1", "L5", "L2", "L3", "L1", "M4", "M3", "L5", "M1", "L2", "M4", "L5", "M1", "L3", "M5",
                "M4", "L2", "L3", "M2", "L2", "L3", "L5", "L2", "W", "L3", "L5", "M2", "M1", "L1", "M4",
                "L3", "M3", "L1", "L3", "M4", "S", "L2", "L5", "M2", "L2", "L5", "M2", "L1", "M1", "L3",
                "L4", "L5", "M2", "L1", "L5", "L2", "M2", "L5", "L1", "L3", "L5", "L4"
            ],
            [
                "L3", "L4", "M2", "L5", "M3", "L4", "L1", "M2", "L3", "M5", "W", "M3", "L1", "M1", "L5",
                "L4", "L1", "W", "L5", "L4", "M2", "M4", "M1", "L4", "M1", "L3", "L5", "M2", "L4", "L1",
                "L3", "M3", "L2", "L4", "M5", "S", "L1", "L4", "M1", "L5", "M5", "M2", "M4", "L3", "L2",
                "L4", "L5", "W", "L1", "L4", "M3", "L2", "L1", "M1", "L3", "M4", "L5", "L2", "M5", "M4",
                "L4", "L5", "M2", "L4", "W", "L5", "L2", "L4", "M4", "L1", "L5", "M4", "L4", "M5", "M4",
                "M1", "W", "L3", "L4", "M4", "L1", "L4", "M1", "L3", "L5", "L1", "L4", "M3", "L3", "L1",
                "L5", "M3", "L3", "M5", "L2", "M4", "L5", "L2", "L3", "L5", "M5", "M1", "L3", "L4", "L5",
                "M3", "L4", "L5", "L1", "M5", "M3", "L1", "M1", "M2", "L3", "W", "L5", "L4", "M4", "L2",
                "L3", "L1", "M1", "W", "L4", "L3", "M2", "L1", "M1", "L4", "M5", "L5", "L1", "M1", "L4",
                "L2", "L3", "M5", "M4", "L4"
            ],
            [
                "L4", "L3", "M3", "M5", "L4", "L1", "M4", "L2", "L4", "M3", "S", "L2", "M4", "L4", "M5",
                "L3", "W", "M3", "L4", "L1", "L3", "L4", "M1", "M3", "M4", "L5", "M3", "M4", "L4", "M1",
                "L2", "M5", "M4", "L5", "M1", "L2", "M4", "L5", "M5", "L2", "M4", "L5", "M3", "M5", "L4",
                "L2", "M5", "L1", "M3", "L2", "M1", "L4", "M5", "M2", "L3", "L1", "W", "L4", "M3", "L2",
                "L4", "M2", "L3", "M4", "L2", "L1", "L3", "L5", "M3", "M4", "L1", "L4", "M2", "L5", "L2",
                "M5", "L1", "L5", "M3", "M4", "L1", "L4", "M2", "L5", "L2", "M5", "L1", "S", "L4", "L2",
                "L3", "M5", "M4", "W", "M2", "L2", "L4", "L1", "L5", "M1", "L3", "M1", "L4", "L1", "M5",
                "L5", "L3", "L5", "M5", "M3", "L2", "L5", "M2", "L2", "M3", "L3", "M5", "W", "L4", "L5",
                "L2", "L4", "M5", "L2", "M3", "M4", "L2", "L3", "M3", "L5", "M2", "L4", "L2", "L1", "M1",
                "W", "L5", "M5", "L4", "L1", "M2", "M1", "L2", "M4", "M3", "M5", "L5", "W", "M3", "L1",
                "M5", "L4", "L5", "S", "M5", "L4", "L5", "M5", "L2", "L4", "M3", "L5", "M1", "L4", "L3",
                "W", "M5", "L5", "M3", "L2", "L5", "L1", "M4", "M3", "M5", "L1"
            ],
            [
                "W", "L2", "L5", "L3", "M4", "M3", "L3", "M2", "L5", "L2", "M2", "W", "L5", "M5", "L3",
                "M2", "L2", "M1", "W", "L1", "L5", "M3", "L3", "L1", "M1", "M5", "M3", "L2", "M4", "L3",
                "W", "L1", "M3", "M4", "L5", "M5", "W", "L3", "L2", "M5", "M4", "L5", "M5", "L3", "M1",
                "M4", "L2", "L4", "S", "L5", "L2", "M1", "L3", "M4", "M5", "L5", "L3", "M5", "L2", "L3",
                "W", "L5", "L1", "M5", "L3", "L4", "M1", "L2", "M2", "M5", "L5", "M3", "W", "L5", "L1",
                "M5", "L3", "L4", "M1", "L2", "M2", "M5", "L5", "M3", "M1", "L3", "M2", "M4", "L5", "M5",
                "M4", "L2", "M1", "L1", "M5", "L5", "M3", "S", "L3", "M5", "M2", "L2", "M1", "L3", "M2",
                "M3", "L2", "M4", "L1", "W", "L2", "M2", "M5", "M1", "L3", "M4", "M3", "L2", "M1", "L5",
                "M4", "L2", "W", "M5", "L3", "L4", "L5", "M4", "L1", "L3", "M3", "M5", "L3", "W", "M4",
                "M2", "L3", "L5", "L2", "M5", "M4", "L2", "L1", "L3", "W", "M3", "M4", "M5", "L5", "L2",
                "M5", "M1", "W", "M3", "L1", "L2", "L3", "M2", "M1", "L2", "L5", "L3", "L2", "L1", "M5",
                "L5", "M3", "L2", "M2", "L4", "M4", "M1", "L2", "L5", "M4"
            ],
            [
                "L1", "L5", "M5", "M1", "M3", "L5", "M4", "L2", "L5", "M5", "M3", "W", "L3", "L4", "M3",
                "M4", "L4", "M5", "L5", "L4", "M1", "L1", "M5", "S", "M3", "L1", "L2", "L4", "M5", "M3",
                "M1", "L3", "L5", "L4", "M4", "W", "L1", "L3", "M1", "L4", "M4", "L3", "W", "M5", "M3",
                "L5", "M4", "L4", "S", "L3", "L2", "L4", "M2", "M5", "M4", "L2", "M2", "L5", "L4", "B",
                "M1", "M5", "L3", "L4", "M4", "L3", "W", "M3", "L5", "M2", "L1", "M1", "L3", "W", "M4",
                "L4", "L5", "M5", "M4", "L4", "L2", "L1", "M1", "L4", "M5", "W", "L2", "L5", "M5", "L3",
                "L5", "M2", "L3", "L4", "L2", "L5", "L1", "M4", "L3", "L4", "L1", "W", "L3", "M1", "M3",
                "L3", "M5", "M3", "L4", "W", "L5", "L2", "L3", "L4", "M3", "M1", "M4", "L4", "L3", "L2",
                "L5", "L4", "L1", "M3", "L3", "M4", "M1", "W", "M1", "L5", "M2", "L1", "M5", "L5", "M4",
                "M5", "M1", "L5", "L3", "L1", "L2", "M3", "L3", "M5", "L5", "B", "L4", "M5", "L3", "M4",
                "L4", "W", "M3", "L5", "L1", "M1", "L4", "M4", "L5", "M3", "M2", "L4", "L3", "S", "M3",
                "L5", "L3", "L2", "M5", "L4", "L3", "L1", "M1", "L5", "L3", "L1", "L5", "M5", "M1", "M3",
                "L5", "M4", "L2", "L5", "M5", "M3", "W", "L3", "L4", "M3", "M4", "L4", "M5", "L5", "L4",
                "M1", "L1", "M5", "S", "M3", "L1", "L2", "L4", "M5", "M3", "M1", "L3", "L5", "L4", "M4",
                "W", "L1", "L3", "M1", "L4", "M4", "L3", "W", "M5", "M3", "L5", "M4", "L4", "S", "L3",
                "L2", "L4", "M2", "M5", "M4", "L2", "M2", "L5", "L4", "M1", "M5", "L3", "L4", "M4", "L3",
                "W", "M3", "L5", "M2", "L1", "M1", "L3", "W", "M4", "L4", "L5", "M5", "M4", "L4", "L2",
                "L1", "M1", "L4", "M5", "W", "L2", "L5", "M5", "L3", "L5", "M2", "L3", "L4", "L2", "L5",
                "L1", "M4", "L3", "L4", "L1", "W", "L3", "M1", "M3", "L3", "M5", "M3", "L4", "W", "L5",
                "L2", "L3", "L4", "M3", "M1", "M4", "L4", "L3", "L2", "L5", "L4", "L1", "M3", "L3", "M4",
                "M1", "W", "M1", "L5", "M2", "L1", "M5", "L5", "M4", "M5", "M1", "L5", "L3", "L1", "L2",
                "M3", "L3", "M5", "L5", "L4", "M5", "L3", "M4", "L4", "W", "M3", "L5", "L1", "M1", "L4",
                "M4", "L5", "M3", "M2", "L4", "L3", "W", "L5", "L2", "L3", "L4", "M3", "M1", "M4", "L4",
                "L3", "L2", "L5", "L4", "L1", "M3", "L3", "M4", "M1", "L3", "L2", "L4", "M2", "M5", "M4",
                "L2", "M2", "L5", "L4"
            ]
        ],
        "NUDGE_RESPIN_REELSET" : [
            [
                "M4", "L5", "L4", "L1", "L2", "M4", "L1", "M2", "L5", "L2", "M1", "L3", "L5", "L4", "M2",
                "L5", "L1", "L2", "M2", "L5", "L3", "M1", "L2", "M4", "L5", "L1", "L4", "M4", "L5", "L1",
                "M4", "L2", "W", "L3", "L4", "L2", "M5", "L3", "L2", "L1", "M2", "L2", "L3", "L5", "L2",
                "M4", "L5", "M3", "L2", "L5", "L3", "L4", "L1", "M5", "M2", "L3", "L1", "M2", "L2", "M5",
                "L5", "M4", "M5", "M1", "W", "L3", "L2", "L4", "L1", "L3", "M3", "L1", "M2", "L2", "L3",
                "M1", "L5", "L2", "L3", "L1", "M4", "M3", "L5", "L2", "M4", "L5", "M1", "L3", "M5", "M4",
                "L2", "L3", "M2", "L2", "L3", "L5", "L2", "W", "M1", "L3", "L5", "M2", "L1", "M4", "L3",
                "M3", "L1", "L3", "M4", "M1", "L2", "L5", "M2", "L2", "L5", "M2", "L1", "L3", "L4", "L5",
                "M2", "L1", "L5", "L2", "M2", "L5", "L1", "L3", "L5", "L4"
            ],
            [
                "L3", "L4", "M2", "L5", "M3", "L4", "L1", "M2", "L3", "M5", "W", "M3", "L1", "L5", "L4",
                "L1", "M1", "W", "L5", "L4", "M2", "M4", "L4", "M1", "L3", "L5", "M2", "L4", "L1", "L3",
                "M3", "L2", "L4", "M5", "M1", "L1", "L4", "L5", "M5", "M2", "M4", "L3", "L2", "L4", "L5",
                "W", "M1", "L1", "L4", "M3", "L2", "L1", "L3", "M4", "L5", "L2", "M5", "M4", "L4", "L5",
                "M2", "L4", "M1", "W", "L5", "L2", "L4", "M4", "L1", "L5", "M4", "L4", "M5", "M4", "W",
                "L3", "L4", "M4", "L1", "L4", "M1", "L3", "L5", "L1", "L4", "M3", "L3", "L1", "L5", "M3",
                "L3", "M1", "M5", "L2", "M4", "L5", "L2", "L3", "L5", "M5", "L3", "L4", "W", "L5", "M3",
                "L4", "L5", "M1", "L1", "M5", "M3", "L1", "M2", "L3", "L1", "L4", "M3", "L1", "M1", "L5",
                "W", "L3", "L1", "M4", "M3", "L4", "M1", "L5", "L3", "L2", "L1", "L3", "M1", "L4", "M3",
                "M5", "L5", "M3", "M1"
            ],
            [
                "L4", "L3", "M3", "M5", "L4", "L1", "M4", "L2", "L4", "M3", "L2", "M4", "L4", "M5", "L3",
                "M1", "W", "M3", "L4", "L1", "L3", "L4", "M1", "M3", "M4", "L5", "M3", "M4", "L4", "L2",
                "M5", "M4", "L5", "M1", "L2", "M4", "L5", "M5", "L2", "M1", "M4", "L5", "M3", "M5", "L4",
                "L2", "M5", "L1", "M3", "L2", "L4", "M5", "M2", "L3", "L1", "M1", "W", "L4", "M3", "L2",
                "L4", "M2", "M1", "L3", "M4", "L2", "L1", "L3", "W", "L5", "M3", "M4", "L1", "L4", "M2",
                "L5", "M1", "L2", "M5", "L1", "L4", "L2", "L3", "M5", "M4", "M1", "W", "M2", "L2", "L4",
                "L1", "L5", "M1", "M1", "L3", "L4", "M1", "L1", "M5", "L5", "W", "M3", "M5", "L3", "L5",
                "L4", "M1", "L3", "L5", "M5", "M3", "L2", "L5", "M2", "L2", "M3", "L3", "M1", "L2", "M4",
                "M3", "M5", "L5", "W", "M3", "L1", "M5", "L4", "L5", "M1", "M5", "L4", "L5", "M5", "L2",
                "L4", "M3", "L5", "L4", "L3", "W", "M1", "M5", "L5", "M3", "L2", "L5", "L1", "M4", "M3",
                "M5", "L1"
            ],
            [
                "W", "L2", "L5", "L3", "M4", "M3", "L3", "M2", "L5", "L2", "M2", "W", "M1", "L5", "M5",
                "L3", "M2", "L2", "W", "L1", "L5", "M3", "L3", "L1", "M1", "M5", "M3", "L2", "M4", "L3",
                "M1", "W", "L1", "M3", "M4", "L5", "M5", "W", "L3", "L2", "M5", "M4", "M1", "L5", "M5",
                "L3", "M4", "L2", "L4", "L5", "L2", "L3", "M4", "M5", "L5", "L3", "M5", "M1", "L2", "L3",
                "W", "L5", "L1", "M5", "L3", "L4", "L2", "M2", "M5", "L5", "M3", "M1", "L3", "M2", "M4",
                "L5", "M5", "M4", "L2", "M1", "L1", "L5", "M3", "L3", "M5", "M2", "L2", "M1", "L3", "M2",
                "M3", "L2", "M4", "L1", "W", "L2", "M2", "M5", "L3", "M4", "M3", "L2", "L5", "M1", "M4",
                "L2", "W", "M5", "L3", "L4", "L5", "M4", "L1", "M1", "L3", "M3", "M5", "L3", "M4", "M2",
                "L3", "L5", "M1", "L2", "M5", "M4", "L2", "L1", "L3", "W", "M4", "M5", "L5", "L2", "M5"
            ],
            [
                "L1", "L5", "M5", "M3", "L5", "M4", "L2", "M1", "L5", "M5", "M3", "W", "L3", "L4", "M3",
                "M4", "L4", "M5", "L5", "L4", "M1", "L1", "M5", "M3", "L1", "L2", "M1", "L4", "M5", "M3",
                "L3", "L5", "L4", "M4", "W", "L1", "L3", "L4", "M4", "L3", "W", "M5", "M3", "L5", "M4",
                "L4", "L3", "L2", "L4", "M2", "M5", "M4", "L2", "M1", "M2", "L5", "L4", "M1", "M5", "L3",
                "L4", "M4", "L3", "M1", "W", "M3", "L5", "M2", "L1", "L3", "W", "M4", "L4", "M1", "L5",
                "M5", "M4", "L4", "L2", "L1", "L4", "M5", "L2", "M2", "L1", "L5", "L3", "M1", "W", "L2",
                "L5", "M5", "L3", "L5", "M2", "L3", "L4", "L2", "L5", "L1", "M4", "L3", "L4", "L1", "W",
                "M1", "M3", "L3", "M5", "M3", "L4", "W", "L5", "L2", "L3", "L4", "M3", "M1"
            ]
        ],
        "SCATTER_RESPIN_REELSET" : [
            [
                "L4", "L5", "L1", "L4", "L5", "L1", "L4", "M5", "L1", "L3", "S", "L5", "L4", "L2", "M5",
                "L3", "L4", "L5", "L1", "M2", "L2", "L5", "L3", "L4", "M2", "L1", "L5", "M2", "L1", "L5",
                "L3", "L4", "M5", "M3", "L1", "L5", "M4", "L2", "L1", "M5", "L3", "L5", "M4", "M5", "M1",
                "L5", "L4", "L1", "L2", "M3", "L1", "M5", "L5", "L1", "L4", "L5", "M5", "L1", "L5", "L4",
                "M5"
            ],
            [
                "M1", "M5", "L4", "L1", "M3", "L4", "L1", "L3", "M3", "M5", "S", "L4", "L1", "M2", "M5",
                "L3", "L4", "L2", "L5", "M3", "M1", "L4", "L2", "M1", "M5", "M3", "M4", "L2", "M2", "M1",
                "L2", "L5", "M1", "L4", "L1", "M4", "L4", "M5", "M4", "L1", "L2", "M3", "L2", "M1", "L4",
                "L2", "M3", "M1", "M2", "M3", "L3"
            ],
            [
                "L4", "L1", "M2", "M5", "L3", "M1", "L1", "M4", "L5", "L1", "S", "L4", "M4", "M3", "L2",
                "M4", "M5", "L1", "L3", "M2", "L1", "M2", "L4", "M5", "M2", "L5", "W", "L3", "M3", "M2",
                "L3", "L1", "M3", "L4", "L3", "L5", "M2", "M3", "M4", "L3", "M3"
            ],
            [
                "M5", "L5", "L1", "M4", "M5", "M3", "L5", "M5", "M2", "L1", "S", "L1", "M3", "L3", "L5",
                "L4", "M5", "L3", "L2", "M1", "M4", "L3", "M2", "L1", "M1", "M4", "L3", "L5", "L2", "M4",
                "L3", "L3", "L2", "M2", "L3", "L1", "M4", "L5", "M2", "M1", "L3"
            ],
            [
                "L5", "L4", "L3", "L2", "L5", "L4", "M4", "L5", "L2", "M5", "S", "M2", "M1", "L5", "L4",
                "L1", "M5", "L4", "L3", "M4", "L5", "M5", "L1", "L2", "M4", "L1", "L3", "M4", "L5", "L2",
                "L3", "L4", "L2", "M5", "L1", "L2", "M5", "L1", "L5", "L4", "M2"
            ]
        ],
        "FREESPIN_REELSET" : [
            [
                "L1", "L4", "M5", "L2", "L1", "L5", "L2", "L4", "L1", "M4", "L4", "M5", "M4", "L2", "L5",
                "L4", "M2", "M4", "L3", "L4", "M5", "M4", "L4", "L3", "M4", "M5", "L5", "L4", "L1", "L5",
                "M1", "M3", "M5", "L1", "M4", "M2", "L4", "L3", "L2", "L5", "M5", "M3", "M4", "L3", "L1",
                "L2", "L5", "L3", "L2", "L4", "L5", "W", "M3", "L1", "L4", "M2", "L1", "L4", "M5", "L3",
                "L1", "L5", "L3", "L4", "L5", "M4", "L3", "L4", "M5", "M4", "L4", "L2", "W", "M4", "L1",
                "L4", "M4", "L1", "L4", "L3", "L5", "L2", "L4", "L1", "L5", "L3", "M3", "M2", "M5", "L3",
                "L4", "M5", "M3", "W", "L4", "L2", "M5", "M4", "L4", "L3", "L1", "L4", "M3", "L1", "L5",
                "M2", "L4", "M4", "L5", "M2", "L4", "L2", "M4", "L5", "M3", "L1", "L2", "M4", "M2", "M5",
                "L1", "M3", "M4", "L3", "W", "L4", "L2", "M5", "L4", "M2", "M5", "L4", "M2", "L3", "L2",
                "L4", "M5", "M3", "L3", "M4", "L4", "L5", "M2", "L4", "M5", "M4", "L4", "L1", "M4", "L5",
                "L3", "L2", "L4", "L1", "M4"
            ],
            [
                "L3", "M2", "L4", "L3", "M5", "L5", "L3", "M3", "M5", "L3", "L4", "M3", "L3", "M2", "L5",
                "L3", "L4", "L1", "L3", "M3", "W", "L2", "L3", "L4", "M3", "L5", "L4", "L3", "M2", "L2",
                "L3", "M3", "L5", "L3", "M2", "L5", "L3", "M3", "M2", "L3", "L4", "M1", "M4", "L2", "L3",
                "L1", "M4", "L3", "L4", "L5", "M3", "L3", "M2", "L5", "M3", "M4", "L2", "L3", "M4", "L4",
                "L3", "M2", "W", "L4", "L3", "L2", "L5", "M5", "M3", "M2", "L3", "L1", "L2", "M2", "L3",
                "M5", "M3", "L4", "M2", "L2", "L1", "L5", "L2", "W", "L4", "L3", "M2", "L2", "L3", "M2",
                "L1", "L3", "L2", "L5", "L4", "M5", "M2", "L3", "L5", "M2", "L4", "L3", "L5", "M2", "W",
                "L2", "L1", "M2", "L4", "L2", "L1", "L3", "L5", "L2", "M4", "M2", "L3", "L5", "L4", "L3",
                "L5", "M3", "L2", "L3", "M2", "M1", "M3", "L5", "L3", "M3", "M2", "L3", "L4", "M2", "L3",
                "M3", "W", "L5", "L2", "L4", "L3", "M5", "M2", "L2", "M5", "L3", "M3", "M2", "L3", "L4",
                "M2", "L3", "M3", "L4", "L2", "M2", "M3"
            ],
            [
                "L5", "M2", "L4", "M3", "L3", "M2", "L5", "M5", "L3", "M3", "W", "M2", "L5", "L3", "L4",
                "M3", "L5", "L4", "M3", "L2", "L3", "M1", "L5", "L2", "L3", "L5", "M2", "M4", "L3", "L5",
                "M3", "L3", "L5", "L4", "L3", "L5", "M5", "L3", "L1", "M2", "L3", "M5", "W", "L5", "L3",
                "M3", "M5", "L5", "L3", "L2", "L5", "M3", "L3", "W", "L2", "M4", "M2", "M5", "L2", "L5",
                "M3", "L3", "L2", "M4", "M1", "L3", "L1", "M3", "L5", "L3", "M3", "L2", "L5", "L3", "L4",
                "W", "L5", "M4", "L2", "L3", "L4", "M2", "M3", "L3", "L5", "M2", "L3", "L5", "L2", "M2",
                "L5", "L2", "M2", "M4", "L5", "M5", "W", "M3", "L4", "L5", "M3", "M2", "L3", "M5", "L5",
                "M3", "L3", "M2", "M3", "M5", "L3", "L2", "M3", "L3", "L4", "M3", "M2", "W", "L3", "L2",
                "L5", "M4", "L3", "L5", "M2", "L3", "L5", "M3", "W", "M2", "L3", "L4", "L5", "L3", "M3",
                "L5", "M5", "M3", "L3", "M1", "L5", "M3", "L3", "M2", "M3", "L3", "M4", "M5", "L5", "L3",
                "W", "M2", "L5", "L1", "L3", "M2", "M3", "L5", "L4", "L3", "M2"
            ],
            [
                "M5", "L4", "L3", "L2", "L4", "M5", "L2", "L5", "L3", "L2", "W", "M5", "L4", "L2", "M5",
                "L4", "L3", "L2", "M5", "L4", "L2", "M1", "L1", "M5", "L2", "L1", "M5", "L4", "M3", "L2",
                "M4", "L3", "L2", "L4", "M5", "L5", "M3", "M5", "L3", "M4", "L2", "L1", "W", "M4", "L4",
                "L1", "L3", "M5", "L2", "L4", "M3", "L5", "L4", "M4", "M2", "L2", "L4", "L1", "L2", "L5",
                "L4", "L1", "M5", "W", "L4", "L1", "M4", "M5", "L3", "L4", "L2", "M4", "L1", "L2", "L3",
                "L1", "M2", "M5", "L4", "M4", "M5", "L2", "L4", "M3", "M1", "L1", "M5", "L2", "L4", "M5",
                "L2", "L4", "M5", "L2", "L3", "M4", "L4", "M5", "L2", "L4", "M5", "M4", "L2", "M5", "M2",
                "W", "M4", "M5", "L2", "L3", "L4", "L1", "L3", "M5", "M4", "L2", "W", "L3", "M5", "M4",
                "L1", "M5", "L4", "L3", "L2", "L4", "L3", "W", "L2", "M5", "L4", "L1", "M5", "L4", "L2",
                "M4", "M3", "L3", "M5", "L4", "L2", "L3", "M3", "L4", "M4", "M5", "L2", "M2", "W", "L1",
                "M4", "L2", "L3", "L4", "L2", "M5", "L5", "L3", "L4"
            ],
            [
                "B", "L5", "L2", "M2", "L4", "L1", "L2", "L5", "M2", "L2", "M5", "B", "L3", "L2", "L5",
                "L3", "L2", "L4", "L5", "L2", "M4", "L3", "W", "L5", "L4", "M4", "L2", "L5", "L3", "L4",
                "L2", "L5", "M2", "M1", "W", "M4", "L5", "L1", "L4", "M2", "B", "L2", "L5", "L1", "M3",
                "L5", "L4", "L3", "L2", "L5", "L3", "L2", "M4", "L3", "M5", "L4", "W", "L3", "L5", "L2",
                "M2", "L1", "L2", "L5", "L4", "L2", "M2", "B", "L4", "L3", "M4", "L5", "L3", "L4", "M2",
                "M5", "L4", "L3", "M4", "L2", "L3", "L1", "L5", "L2", "M4", "L5", "M2", "L3", "B", "L2",
                "L4", "L3", "L5", "M5", "L2", "L5", "M3", "M4", "L3"
            ]
        ],
        "NUDGE_RESPIN_FS_REELSET" : [
            [
                "M4", "L5", "L4", "L1", "L2", "M4", "L1", "M2", "L5", "L2", "M1", "L3", "L5", "L4", "M2",
                "L5", "L1", "L2", "M2", "L5", "L3", "M1", "L2", "M4", "L5", "L1", "L4", "M4", "L5", "L1",
                "M4", "L2", "W", "M1", "L3", "L4", "L2", "M5", "L3", "L2", "L1", "M2", "L2", "L3", "M4",
                "L5", "L3", "L1", "M4", "L5", "M2", "L3", "M4", "L2", "M1", "L5", "L2", "L3", "L1", "M4",
                "M3", "L5", "L2", "M4", "L5", "M1", "L3", "M5", "M4", "L2", "L3", "M2", "L2", "L3", "L5",
                "L2", "M1", "L3", "L5", "M2", "L1", "M4", "L3", "M3", "L1", "L3", "M4", "M1", "L2", "L5",
                "M2", "L2", "L5", "M2", "L1", "L3", "L4", "L5", "M2", "L1", "L5", "L2", "M2", "L5", "L1",
                "L3", "L5", "L4"
            ],
            [
                "L3", "L4", "M2", "L5", "M3", "L4", "L1", "M2", "L3", "M5", "M1", "M3", "L1", "L5", "L4",
                "L1", "M1", "W", "L5", "L4", "M2", "M4", "L4", "M1", "L3", "L5", "M2", "L4", "L1", "L3",
                "M3", "L2", "L4", "M5", "L1", "L4", "L5", "M5", "M2", "M4", "L3", "L2", "L4", "L5", "L1",
                "L4", "M3", "L2", "L1", "M1", "L3", "M4", "L5", "L2", "M5", "M4", "L4", "L5", "M2", "L4",
                "W", "L5", "L2", "M1", "L4", "M4", "L1", "L5", "M4", "L4", "M5", "M4", "M1", "W", "L3",
                "L4", "M4", "L1", "L4", "M1", "L3", "L5", "L1", "L4", "M3", "L3", "L1", "M1", "L5", "M3",
                "L3", "M5", "L2", "M4", "L5", "L2", "L3", "L5", "M5", "L3", "L4", "L5", "M3", "L4", "L5",
                "L1", "M1", "M5", "M3", "L1", "M2", "L3", "L1", "L4", "M3", "L1", "L5", "W", "L3", "L1",
                "M4", "M3", "L4", "M1", "L5", "L3", "L2", "L1", "M1", "L3", "L4", "M3", "M5", "L5", "M3",
                "M1", "L4", "M5", "L5", "L1", "L4", "L2", "L3", "M5", "M4", "L4"
            ],
            [
                "L4", "L3", "M3", "M5", "L4", "L1", "M4", "L2", "L4", "M3", "L2", "M4", "L4", "M5", "L3",
                "W", "M3", "L4", "L1", "L3", "L4", "M3", "M4", "L5", "M3", "M4", "L4", "M1", "L2", "M5",
                "M4", "L5", "M1", "L2", "M4", "L5", "M5", "L2", "M4", "L5", "M1", "M3", "M5", "L4", "L2",
                "M5", "L1", "M3", "L2", "M1", "L4", "M5", "M2", "L3", "L1", "L4", "M3", "L2", "L4", "M1",
                "M2", "L3", "M4", "L2", "L1", "L3", "L5", "M3", "M4", "L1", "L4", "M2", "L5", "M1", "L2",
                "M5", "L1", "L4", "M1", "L2", "L3", "M5", "M4", "W", "M2", "L2", "L4", "L1", "L5", "M1",
                "L3", "L4", "L1", "M5", "L5", "M1", "W", "M3", "M5", "L3", "L5", "L4", "L3", "L5", "M5",
                "M3", "L2", "M1", "L5", "M2", "L2", "M3", "L3", "M1", "L2", "M4", "M3", "M5", "L5", "W",
                "M3", "L1", "M5", "L4", "L5", "M5", "L4", "L5", "M5", "L2", "M1", "L4", "M3", "L5", "L4",
                "L3", "M5", "L5", "M3", "L2", "L5", "L1", "M4", "M3", "M5", "L1"
            ],
            [
                "W", "L2", "L5", "L3", "M4", "M3", "L3", "M2", "M1", "L5", "L2", "M2", "L5", "M5", "L3",
                "M2", "L2", "W", "L1", "L5", "M3", "L3", "L1", "M1", "M5", "M3", "L2", "M4", "L3", "W",
                "L1", "M3", "M4", "L5", "M5", "L3", "L2", "M5", "M4", "L5", "M5", "M1", "L3", "M4", "L2",
                "L4", "L5", "L2", "L3", "M4", "M5", "L5", "L3", "M5", "L2", "L3", "L5", "L1", "M5", "L3",
                "L4", "L2", "M2", "M5", "L5", "M3", "L2", "M2", "M1", "M5", "L3", "M4", "M3", "L2", "L5",
                "M4", "L2", "W", "M5", "L3", "L4", "L5", "M4", "L1", "M1", "L3", "M3", "M5", "L3", "M4",
                "M2", "L3", "L5", "L2", "M5", "M4", "L2", "L1", "L3", "M4", "M5", "L5", "L2", "M5", "W",
                "M3", "L1", "L2", "L3", "M2", "M1", "L2", "L5", "L3", "L2", "L1", "L4", "L3", "L2", "L5",
                "L1", "M1", "W", "M2", "L5", "M3", "L4", "L2", "L3", "L1", "M3", "L3", "M4", "M5", "L5",
                "M3", "L2", "M2", "L4", "M4", "L2", "L5", "M4"
            ],
            [
                "L1", "L5", "M5", "M3", "L5", "M4", "L2", "L5", "M5", "M3", "W", "L3", "L4", "M3", "M4",
                "L4", "M1", "M5", "L5", "L4", "L1", "M5", "M3", "L1", "L2", "L4", "M5", "M3", "M1", "L3",
                "L5", "L4", "M4", "L1", "L3", "L4", "M4", "L3", "W", "M5", "M3", "L5", "M4", "L4", "L3",
                "L2", "L4", "M2", "M5", "M4", "L2", "M2", "L5", "L4", "M1", "M5", "L3", "L4", "M4", "L3",
                "W", "M3", "L5", "M2", "L1", "L3", "M4", "L4", "L5", "M5", "M4", "L4", "L2", "L1", "L4",
                "M5", "M1", "L2", "M2", "L1", "L5", "L3", "W", "L2", "L5", "M5", "L3", "L5", "M2", "L3",
                "L4", "L2", "L5", "L1", "M4", "L3", "L4", "M1", "L1", "M3", "L3", "M5", "M3", "L4", "W",
                "L5", "L2", "L3", "L4", "M3", "M1", "M4", "L4", "L3", "L2", "L5", "L4", "L1", "M3", "L3",
                "M1", "M4", "L5", "M2", "L1", "M1", "M5", "L5", "M4", "M5", "L5", "L3", "L1"
            ]
        ]
    };

    WIN_RATIOS:IWinRatios = {
        normalWin : [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0,
                type : WinRatioType.TINY
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 0,
                type : WinRatioType.SMALL
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 1,
                type : WinRatioType.MEDIUM
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 1.25,
                type : WinRatioType.LARGE
            }
        ],
        bigWin : [
            {
                ratio : 15,
                text : "Big Win",
                duration : 7.815,
                type : WinRatioType.BIG_WIN
            },
            {
                ratio : 25,
                text : "Mega Win",
                duration : 7.680,
                type : WinRatioType.MEGA_WIN

            },
            {
                ratio : 50,
                text : "Super Mega Win",
                duration : 7.680,
                type : WinRatioType.SUPER_MEGA_WIN
            }
        ]
    };

    PERFORMANCE_LOGGER:boolean = true;

    // #311
    WIN_BELOW_STAKE: boolean = false;

    private constructor() {
        if(ThorGameConfig.instance) {
            throw new Error("ThorGameConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}